"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PIMDataEntry2 = _interopRequireDefault(require("./PIMDataEntry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DATA_KEY = {
  STYLE_ID: 'styleId',
  NAME: 'name',
  DESCRIPTION: 'description',
  TECHNICAL_DESCRIPTION: 'technicalDescription',
  IMAGE: 'image',
  IMAGE_URL: 'imageUrl',
  IMAGE_TAGS: 'tag'
};

var PIMStyle = /*#__PURE__*/function (_PIMDataEntry) {
  _inherits(PIMStyle, _PIMDataEntry);

  var _super = _createSuper(PIMStyle);

  /**
   * @param {object} data
   * @constructor
   * @example
   */
  function PIMStyle(data) {
    var _this;

    _classCallCheck(this, PIMStyle);

    _this = _super.call(this);
    /**
     * @type {number}
     */

    _this.styleId = parseInt(_this.getString(data, DATA_KEY.STYLE_ID, -1), 10);
    /**
     * @type {string}
     */

    _this.name = _this.getString(data, DATA_KEY.NAME, '');
    /**
     * @type {string}
     */

    _this.description = _this.getString(data, DATA_KEY.DESCRIPTION, '');
    /**
     * @type {string}
     */

    _this.technicalDescription = _this.getString(data, DATA_KEY.TECHNICAL_DESCRIPTION, '');
    /**
     * @type {string}
     */

    _this.image = function () {
      if (!data) return null;

      var imageData = _this.getRaw(data, DATA_KEY.IMAGE);

      if (!imageData) return null;
      return {
        url: _this.getString(imageData, DATA_KEY.IMAGE_URL),
        tags: _this.getArray(imageData, DATA_KEY.IMAGE_TAGS, [])
      };
    }();

    return _this;
  }

  return PIMStyle;
}(_PIMDataEntry2["default"]);

var _default = PIMStyle;
exports["default"] = _default;